import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { PrelanderV48Page } from './ui/pages/PrelanderV48Page';
import { PrelanderV47Page } from './ui/pages/PrelanderV47Page';
import { PrelanderV46Page } from './ui/pages/PrelanderV46Page';
import { getPurchaseData } from './lib/use-cases/get-purchase';
import { getFbclid } from './lib/shared/ad-helpers';
import { amplitudeTracker } from './lib/shared/amplitude-tracker';
import { setCustomHeightVariable } from './lib/shared/dimensions';
import { sentryLogger } from './lib/shared/sentry-logger';
import { growthBook } from './lib/shared/growthbook';
import config from './config';
import '@virtualstate/navigation/polyfill';
import './common.css';

sentryLogger.init(config.environment);

const PATH_NAMES = ['', '/v48', '/v47', '/v46'];

amplitudeTracker.init(config.amplitudeApiKey, config.amplitudeServerUrl);
amplitudeTracker.onSubscribe();

const growthBookInstance = growthBook.init(config.growthBookApiHost, config.growthBookClientKey);

growthBook.setUserAttributes();
growthBook.onSubscribe();

function App() {
    useEffect(() => {
        setCustomHeightVariable();
        window.addEventListener('resize', setCustomHeightVariable);
        growthBook.loadFeatures();

        if (PATH_NAMES.includes(window.location.pathname)) {
            const purchaseData = getPurchaseData();

            if (getFbclid(window.location.search) && purchaseData.subscriptionId) {
                window.location.replace(`${config.platformUrl}/dashboard`);
            }
        }
    }, []);

    const renderPage = () => {
        if (window.location.pathname === '/v48') {
            return <PrelanderV48Page initialPrelander='v48.1' />;
        }

        if (window.location.pathname === '/v47') {
            return <PrelanderV47Page initialPrelander='v47' />;
        }

        if (window.location.pathname === '/v46') {
            return <PrelanderV46Page initialPrelander='v46' />;
        }

        if (window.location.pathname === '/') {
            return <PrelanderV48Page initialPrelander='v48.1' />;
        }

        return window.location.replace('/');
    };

    return (
        <GrowthBookProvider growthbook={growthBookInstance}>
            {renderPage()}
        </GrowthBookProvider>
    );
}

const root = createRoot(document.getElementById('root'));

root.render(<App />);
